import { render, staticRenderFns } from "./ThickOrThin.vue?vue&type=template&id=1a37f864&"
import script from "./ThickOrThin.vue?vue&type=script&lang=js&"
export * from "./ThickOrThin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports